import React from 'react';
import clsx from 'clsx';
import { useMatchMedia } from '../../utils';
import Close from '@mollie/ui-assets/icons/utilitarian/Close';
import { useThemeName } from '../ThemeProvider/ThemeProvider';
import { Box } from '../Box';
import { Button } from '../Button';
import { Text } from '../Text';
import { ButtonIcon } from '../ButtonIcon';
import { BannerProduct } from './BannerProduct';
import './Banner.css';
const BannerComponent = React.forwardRef(function Banner(props, ref) {
    const { className, topComplement, title, titleShort, action, imageSrc, imageSmallSrc, imageDarkSrc, imageSmallDarkSrc, imageAlt = '', dismissible = true, onDismiss, ariaDismissLabel, ...restProps } = props;
    const theme = useThemeName();
    const isUpToSmallViewport = useMatchMedia('to-small');
    const isUpToExtraSmallViewport = useMatchMedia('to-extra-small');
    const largeImageSrc = theme === 'dark' ? imageDarkSrc || imageSrc : imageSrc;
    const smallImageSrc = theme === 'dark' ? imageSmallDarkSrc || imageSmallSrc : imageSmallSrc;
    const responsiveImageSrc = isUpToSmallViewport
        ? smallImageSrc
        : largeImageSrc;
    function handleClick(e) {
        var _a;
        e.stopPropagation();
        if (((_a = e.currentTarget.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'button' ||
            isUpToSmallViewport) {
            action === null || action === void 0 ? void 0 : action.onClick();
        }
    }
    return (React.createElement(Box.Restricted, { ...restProps, className: clsx('mollie-ui-banner', className), onClick: handleClick, role: "banner", ref: ref },
        React.createElement("div", { className: "mollie-ui-banner-content" },
            React.createElement(Box, { className: "mollie-ui-banner-top-complement", hidden: !topComplement }, topComplement),
            (title || titleShort) && (React.createElement(Text, { variant: {
                    base: 'heading-title-4',
                    small: 'subtitle-medium',
                }, className: "mollie-ui-banner-title" }, isUpToExtraSmallViewport ? titleShort : title)),
            action && (React.createElement(Button, { onClick: handleClick, size: "medium", "aria-label": action.ariaLabel, hidden: isUpToSmallViewport }, action.label))),
        responsiveImageSrc && (React.createElement("img", { className: "mollie-ui-banner-image", src: responsiveImageSrc, alt: imageAlt })),
        dismissible && (React.createElement(ButtonIcon, { className: "mollie-ui-banner-close", src: Close, size: {
                base: 'medium',
                small: 'small',
            }, "aria-label": ariaDismissLabel, onClick: (e) => {
                e.stopPropagation();
                onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            } }))));
});
BannerComponent.displayName = 'Banner';
export const Banner = Object.assign(BannerComponent, {
    Product: BannerProduct,
});
//# sourceMappingURL=Banner.js.map